/**
 * Hoffmann Vorbestellung – Theme-Skript
 * Einbinden in theme.liquid vor </body>:
 *   <script src="{{ 'preorder.js' | asset_url }}" defer></script>
 *
 * Anpassen an das Theme über window.PreorderConfig (optional, vor dem Skript setzen).
 */
(function () {
  'use strict';

  var C = Object.assign(
    {
      productForm: 'form[action*="/cart/add"]',
      submitButton: '[type="submit"][name="add"], button[type="submit"]',
      buttonLabel: null, // z. B. '.btn__text' – falls der Text in einem inneren span steht
      deliveryAfter: null, // z. B. '.product-form__buttons' – Liefertext unter diesen Container statt direkt unter den Button
      onButton: null, // function (button, state, active) – Theme-spezifische Zusatzlogik
      refreshCart: null, // function () – Theme-spezifisches Neuladen des Warenkorbs (Promise)
      showDelivery: true, // false oder function (form) – Liefertext unter dem Button zeigen?
      hideOnPreorder: null, // z. B. '.pay-row' – Elemente der Seite, die bei Vorbestellung verschwinden (Klarna-/PayPal-Hinweise)
      notifyForm: '[data-back-in-stock], .back-in-stock, .klaviyo-bis-trigger',
      pdpBadge: '[data-preorder-pdp-badge]',
      expressButtons: '.shopify-payment-button, shopify-accelerated-checkout',
      cartRefreshEvent: 'cart:refresh', // Event, auf das die Warenkorb-Schublade neu lädt
      reloadIfNoListener: true,
    },
    window.PreorderConfig || {}
  );

  /* ---------------- Produktseite ---------------- */

  function initProduct(dataEl) {
    var states;
    try {
      states = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var byId = {};
    states.forEach(function (s) {
      byId[String(s.id)] = s;
    });

    var form = dataEl.closest(C.productForm) || document.querySelector(C.productForm);
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    // Alle Kauf-Buttons des Formulars – auch solche außerhalb (form="…", z. B. Sticky-Leiste).
    function buttons() {
      var list = Array.prototype.slice.call(form.querySelectorAll(C.submitButton));
      if (form.id) {
        document.querySelectorAll('button[form="' + form.id + '"]').forEach(function (b) {
          if (b.type === 'submit' && list.indexOf(b) === -1) list.push(b);
        });
      }
      return list;
    }
    function labelOf(button) {
      return (C.buttonLabel && button.querySelector(C.buttonLabel)) || button;
    }

    var main = buttons()[0];
    if (!main) return;
    var delivery = document.createElement('p');
    delivery.className = 'preorder-delivery';
    delivery.setAttribute('data-preorder-delivery', '');
    delivery.hidden = true;
    var anchor = (C.deliveryAfter && main.closest(C.deliveryAfter)) || main;
    anchor.insertAdjacentElement('afterend', delivery);

    var lastId = null;

    function apply() {
      var id = String(idInput.value);
      var s = byId[id] || { preorder: false, blocked: false };
      var active = s.preorder && !s.blocked;

      // Button-Texte bei jedem Durchlauf erzwingen: Themes schreiben sie nach Variantenwechsel neu.
      buttons().forEach(function (button) {
        var label = labelOf(button);
        if (active) {
          if (!button.hasAttribute('data-preorder-active')) {
            button.setAttribute('data-preorder-original', label.textContent);
            button.setAttribute('data-preorder-active', '');
          }
          if (label.textContent !== s.button) label.textContent = s.button;
        } else if (button.hasAttribute('data-preorder-active')) {
          // Nur zurücksetzen, wenn der Text noch unserer ist – sonst hat das Theme ihn schon neu gesetzt.
          if (label.textContent === button.getAttribute('data-preorder-text')) {
            label.textContent = button.getAttribute('data-preorder-original');
          }
          button.removeAttribute('data-preorder-active');
        }
        if (active) button.setAttribute('data-preorder-text', s.button);
        // Obergrenze erreicht, aber Flow hat noch nicht umgeschaltet → nicht kaufbar.
        // Nur selbst gesperrte Buttons wieder freigeben – Ausverkauft-Sperren des Themes bleiben.
        if (s.blocked) {
          button.disabled = true;
          button.setAttribute('data-preorder-disabled', '');
        } else if (button.hasAttribute('data-preorder-disabled')) {
          button.disabled = false;
          button.removeAttribute('data-preorder-disabled');
        }
        if (typeof C.onButton === 'function') C.onButton(button, s, active);
      });

      if (id === lastId) return;
      lastId = id;

      var showDelivery = typeof C.showDelivery === 'function' ? C.showDelivery(form) : C.showDelivery !== false;
      delivery.textContent = active ? s.text : '';
      delivery.hidden = !active || !showDelivery;

      // Benachrichtigungs-Formular: bei Vorbestellung aus, bei erreichter Obergrenze an,
      // sonst entscheidet das Theme.
      if (active) override(C.notifyForm, false, form);
      else if (s.blocked) override(C.notifyForm, true, form);
      else restore(C.notifyForm, form);

      // Express-Buttons (PayPal, Apple Pay …) umgehen die Zahlarten-Auswahl → bei Vorbestellung aus.
      if (active) override(C.expressButtons, false, form);
      else restore(C.expressButtons, form);
      if (active) override(C.hideOnPreorder, false, document);
      else restore(C.hideOnPreorder, document);

      // Badge-Platzhalter: zuerst im eigenen Formular suchen (mehrere Produkte/Quick-View auf einer Seite),
      // sonst seitenweit.
      var badgeRoot = form.querySelector(C.pdpBadge) ? form : document;
      override(C.pdpBadge, active, badgeRoot);

      form.dispatchEvent(new CustomEvent('preorder:change', { bubbles: true, detail: s }));
    }

    // Themes melden Variantenwechsel unterschiedlich – wir hören auf alles.
    form.addEventListener('change', function () {
      setTimeout(apply, 0);
    });
    form.addEventListener('variant:change', function () {
      setTimeout(apply, 0);
    });
    document.addEventListener('variant:change', function () {
      setTimeout(apply, 0);
    });
    new MutationObserver(apply).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    // Fallback für Themes, die nur .value setzen (kein Attribut, kein Event) oder Texte nachträglich überschreiben
    setInterval(apply, 400);
    apply();
  }

  // Sichtbarkeit setzen und merken, dass wir es waren (damit restore() nur Eigenes zurücknimmt).
  function override(selector, show, root) {
    if (!selector) return;
    (root || document).querySelectorAll(selector).forEach(function (el) {
      if (!el.hasAttribute('data-preorder-display')) {
        el.setAttribute('data-preorder-display', el.style.display || '-');
      }
      el.style.display = show ? (el.style.display === 'none' ? '' : el.style.display) : 'none';
      if (show) el.hidden = false;
    });
  }

  function restore(selector, root) {
    if (!selector) return;
    (root || document).querySelectorAll(selector).forEach(function (el) {
      var prev = el.getAttribute('data-preorder-display');
      if (prev === null) return;
      el.style.display = prev === '-' ? '' : prev;
      el.removeAttribute('data-preorder-display');
    });
  }

  /* ---------------- Warenkorb: Teillieferung ---------------- */

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart ' + r.status);
      return r.json();
    });
  }

  // Das Theme lädt die Schublade neu und ruft e.preventDefault() auf, um „erledigt“ zu melden.
  // Ohne Theme-Listener: Seite neu laden (sicher, aber langsamer).
  function refreshCart() {
    if (typeof C.refreshCart === 'function') return C.refreshCart();
    var ev = new CustomEvent(C.cartRefreshEvent, { bubbles: true, cancelable: true });
    var handled = !document.dispatchEvent(ev);
    if (!handled && C.reloadIfNoListener) window.location.reload();
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    var wrap = input && input.closest && input.closest('[data-preorder-partial]');
    if (!wrap) return;
    input.disabled = true;
    var req = input.checked
      ? post('/cart/add.js', { items: [{ id: Number(wrap.getAttribute('data-fee-variant')), quantity: 1 }] })
      : post('/cart/change.js', { id: wrap.getAttribute('data-fee-line'), quantity: 0 });
    req
      .then(refreshCart)
      .catch(function () {
        input.checked = !input.checked;
      })
      .finally(function () {
        input.disabled = false;
      });
  });

  var removing = false;
  function removeOrphanFee() {
    var el = document.querySelector('[data-preorder-fee-orphan]');
    if (!el || removing) return;
    removing = true;
    post('/cart/change.js', { id: el.getAttribute('data-preorder-fee-orphan'), quantity: 0 })
      .then(refreshCart)
      .catch(function () {})
      .finally(function () {
        removing = false;
      });
  }

  /* ---------------- Start ---------------- */

  function boot() {
    document.querySelectorAll('script[data-preorder-product]').forEach(function (el) {
      if (el.__preorder) return;
      el.__preorder = true;
      initProduct(el);
    });
    removeOrphanFee();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Warenkorb-Schublade und Quick-View werden nachgeladen → erneut prüfen.
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();
